import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MuiBannerModule, MuiIconModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuAnnouncementComponent } from './mmu-announcement-banner/mmu-announcement.component';


@NgModule({
  declarations: [MmuAnnouncementComponent],
  imports: [CommonModule, MuiBannerModule, MuiIconModule, TranslateModule],
  exports: [MmuAnnouncementComponent]
})
export class MmuAnnouncementModule {}
